// ABOUTME: Ponto de entrada do Alpine.js — inicializa e expõe a instância global.
// ABOUTME: Expõe window.Alpine apenas em development via meta tag de environment.

import { railsEnv } from "@uenf/layout"
import Alpine from "alpinejs"
if (railsEnv === "development") {
  window.Alpine = Alpine
}
Alpine.start()
